// to use when we have html paren and its child
export const getOffset = (parent: HTMLElement, child: HTMLElement): number => {
    const rectParent = parent.getBoundingClientRect();
    const rectChild = child.getBoundingClientRect();

    return parent.scrollTop + rectChild.top - rectParent.top;
};

